module.exports = __webpack_public_path__ + "static/media/ordini1.71cdccc7.png";